// dateString format: `2020-12-31`
export function isToday(dateString: string | Date): boolean {
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	const date = new Date(dateString)
	date.setHours(0, 0, 0, 0)

	return today.getTime() === date.getTime()
}
